import React, { useState, useEffect } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { reSendMobileOTP, verifyMobileOTPAPI } from '../utils/api';
import loadingif from "../assets/loading-gif.gif";

const MobileOTP = () => {
    const [mobileotp, setMobileOTP] = useState("");
    const [loading, setLoading] = useState(false);
    const [resendTimer, setResendTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const mobile = localStorage.getItem("subagentmobile");
        if (!mobile) {
            toast.error("Session expired. Please login again.");
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
            return () => clearTimeout(timer);
        } else {
            setCanResend(true);
        }
    }, [resendTimer]);

    const NumericOnly = (e) => {
        const reg = /^[0-9\b]+$/
        let preval = e.target.value
        if (e.target.value === '' || reg.test(e.target.value)) {
            setMobileOTP(e.target.value)
        } else {
            e.target.value = preval.substring(0, (preval.length - 1))
        }
    }

    const handleOTPSubmit = async (e) => {
        e.preventDefault();
        const mobile = localStorage.getItem("subagentmobile");

        if (mobileotp.length === 4) {
            setLoading(true);
            const mobiledata = { mobile, mobileotp };

            verifyMobileOTPAPI("sub-agent-verify-mobile-otp", mobiledata)
                .then((res) => {
                    if (res.data.status === 1) {
                        localStorage.setItem("subagentdata", res.data.data);
                        toast.success(res.data.msg);
                        navigate("/dashboard");
                    } else {
                        toast.error(res.data.msg);
                    }
                })
                .catch(() => {
                    toast.error("Something went wrong. Please try again.");
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            toast.error("Please enter a valid 4-digit OTP!");
        }
    }

    const resendMobileOTP = () => {
        if (!canResend) return; 
        const mobile = localStorage.getItem("subagentmobile");

        if (mobile && mobile.length === 10) {
            reSendMobileOTP("sub-agent-resend-mobile-otp", mobile)
                .then((res) => {
                    if (res.data.status === 1) {
                        toast.success("Mobile OTP has been sent!");
                        setResendTimer(30);
                        setCanResend(false);
                    } else {
                        toast.error("Failed to resend OTP. Try again.");
                    }
                })
                .catch(() => {
                    toast.error("Something went wrong. Please try again.");
                });
        } else {
            toast.error("Invalid Mobile Number!");
        }
    }

    return (
        <div className="homePage">
            <Helmet>
                <title>SATKARTAR:MOBILE OTP</title>
            </Helmet>
            <div className="container h-100">
                <div className="d-flex justify-content-center h-100">
                    <div className="user_card">
                        <div className="d-flex justify-content-center">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Logo" />
                            </div>
                            <h2 className="loginnames">SUB AGENT LOGIN</h2>
                        </div>
                        <div className="d-flex justify-content-center form_container">
                            <form onSubmit={handleOTPSubmit} method="post">
                                <div className="form-group">
                                    <label htmlFor="subagent_otp">Enter Mobile OTP</label>
                                    <input
                                        type="text"
                                        name="subagent_otp"
                                        className="form-control input_user"
                                        id="subagent_otp"
                                        placeholder="Enter the 4-digit OTP"
                                        onChange={NumericOnly}
                                        required={true}
                                        maxLength={4}
                                    />
                                </div>
                                <div className="d-flex justify-content-end login_container">
                                    <button
                                        type="button"
                                        className="reSendMobileOTP"
                                        onClick={resendMobileOTP}
                                        disabled={!canResend}
                                        style={{ opacity: canResend ? 1 : 0.5, cursor: canResend ? 'pointer' : 'not-allowed' }}
                                    >
                                        {canResend ? "Re-Send OTP" : `Re-Send OTP (${resendTimer}s)`}
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center mt-3 login_container">
                                    {loading ?
                                        <button disabled={true} type="submit" className="btn login_btn">
                                            <img src={loadingif} alt="loading" style={{ width: "7%", marginTop: "-3px" }} /> {/* ✅ FIX 6 */}
                                            VERIFYING...
                                        </button>
                                        :
                                        <button type="submit" className="btn login_btn">LOGIN</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileOTP